export default "<app-inner-layout>\r\n  <animate-when-reached>contact works!</animate-when-reached>\r\n</app-inner-layout>\r\n"